/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M13.4183 7.9742a1.8701 1.8701 0 0 0-2.3366 0l-.0257.0205a1.9112 1.9112 0 0 0-.6951 1.7832l.8895 5.782c.1274.828 1.3043.8718 1.4927.0554l1.3293-5.7601a1.8703 1.8703 0 0 0-.6541-1.881ZM12 20c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.25.75A.75.75 0 0 1 10 0h4a.75.75 0 0 1 0 1.5h-1.25v1.5264c2.4605.1736 4.687 1.195 6.389 2.774l1.2682-1.2682a.75.75 0 0 1 1.0606 1.0607l-1.3037 1.3037C21.6249 8.7004 22.5 10.998 22.5 13.5 22.5 19.299 17.799 24 12 24S1.5 19.299 1.5 13.5c0-2.502.8751-4.7996 2.336-6.6034L2.5321 5.5928a.75.75 0 0 1 1.0606-1.0606L4.861 5.8003C6.563 4.2214 8.7895 3.2 11.25 3.0263V1.5H10a.75.75 0 0 1-.75-.75ZM21 13.5c0 4.9706-4.0294 9-9 9s-9-4.0294-9-9 4.0294-9 9-9 9 4.0294 9 9Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'IncidentCount'
);
